export default "__VITE_ASSET__hvjaLtpt__"